import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./track-page.module.css";
import "../App.css";
import { Collapse } from "reactstrap";
function CustomerInfo({ data, isOpen }) {
  return (
    <Collapse isOpen={isOpen}>
      <p className={styles.main_info}>Customer Information</p>
      <Container className={styles.main_info_container}>
        <Col md={6} sm={12}>
          <Col md={12} style={{ textAlign: "center" }}>
            <h6 className="fw-bold">Shipper Information</h6>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Shipper: </p>
              </Col>
              <Col className="fw-normal">
                <p>{data?.sender?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Phone: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.sender?.phone}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Company: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.sender?.company}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Address: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.sender?.address}</p>
              </Col>
            </Row>
          </Col>
        </Col>

        <Col md={6} sm={12}>
          <Col md={12} style={{ textAlign: "center" }}>
            <h6 className="fw-bold">Consignee Information</h6>
          </Col>{" "}
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Consignee: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.receiver?.name}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Phone: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.receiver?.phone}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Company: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.receiver?.company}</p>
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col className={styles.main_info_title}>
                <p>Address: </p>
              </Col>
              <Col>
                <p className="fw-normal">{data?.receiver?.address}</p>
              </Col>
            </Row>
          </Col>
        </Col>
      </Container>
    </Collapse>
  );
}

export default CustomerInfo;
